import { styled } from "@mui/material";

const Text = styled(`span`)`
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  color: red;
`;

export const RequiredMark = () => <Text>*</Text>;
